<template>
  <div>
  </div>
  <!--
  <div v-if="menuStyle === MENU_STYLE_BURGER">
    <slide right noOverlay>
      <template v-for="(page, index) in menuPages" >
        <a :class="aClass" :href="`/`+ page.slug">
          <component :is="menuConfig.titleTag">{{ page.title }}</component>
        </a>
      </template>
      <a v-if="privacy === PRIVACY_STATUS_PRIVATE" :class="aClass" :href="menuConfig.accessLink.url">
        <component :is="menuConfig.titleTag">{{ menuConfig.accessLink.title }}</component>
      </a>
    </slide>
  </div>
  <div v-else>
    <ul :id="ulId" :class="ulClass">
      <slot name="append_start"/>
      <li :class="liClass" v-for="(page, index) in menuPages" :key="index">
        <a :class="aClass" :href="`/`+ page.slug">
          <component v-if="showIcon" :is="menuConfig.iconTag" :class="menuConfig.iconPrefix+fetchIcon(page.icon)"></component>
          <component :is="menuConfig.titleTag">{{ page.title }}</component>
        </a>
      </li>
      <li v-if="privacy === PRIVACY_STATUS_PRIVATE" :class="liClass">
        <a :class="aClass" :href="menuConfig.accessLink.url">
          <component v-if="showIcon" :is="menuConfig.iconTag" :class="menuConfig.accessLink.icon"></component>
          <component :is="menuConfig.titleTag">{{ menuConfig.accessLink.title }}</component>
        </a>
      </li>
      <slot name="append_end"/>
    </ul>
  </div>
  -->
</template>
<script>
  import { Slide } from 'vue-burger-menu'
  import page from '@fremcast/section/mixins/page-legacy';
  import * as PageMenuConfig from '@fremcast/section/config';
  const PRIVACY_STATUS_PRIVATE = 1;
  const MENU_STYLE_BURGER = 'burger-menu'
  export default {
    data() {
      return {
        menu: 'Menu',
        privacy: 1,
        PRIVACY_STATUS_PRIVATE,
        MENU_STYLE_BURGER,
        menuConfig: PageMenuConfig.default['skrn'].menu,
        navOffset: 20
      };
    },
    props: {
      ulId: {
        type: String,
        default: '__menu_id'
      },
      aClass: {
        type: String,
        default: ''
      },
      ulClass: {
        type: String,
        default: ''
      },
      liClass: {
        type: String,
        default: ''
      },
      showIcon: {
        type: Boolean,
        default: true
      },
      menuStyle: {
        type: String,
        default: ''
      }
    },
    components: {
      Slide
    },
    mixins: [
      page
    ],
    mounted() {
      
      this.fetchPages();
      
      if (this.privacy === PRIVACY_STATUS_PRIVATE && this.menuPages[0].access === 'private') {
        this.menuConfig.accessLink = this.menuConfig.homeLink
      }
    },
    methods: {
      fetchIcon(icon) {
        return _.has(this.menuConfig.icons, icon) ? this.menuConfig.icons[icon] : this.menuConfig.defaultIcon;
      },
      setOffset: function(offset) {
        this.navOffset = offset
      },
    }
  }
</script>
